import React, { Suspense, lazy } from "react";

import Loading from "@Core/Components/Loading";

const LoginWrapper = lazy(() =>
  import(/* webpackChunkName: "login" */ "./view")
);

const HomeWrapper = (props) => {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <LoginWrapper {...props} />
      </Suspense>
    </>
  );
};

export default HomeWrapper;